"use client";
import React from "react";
import Image from "next/image";
import {
  Center,
  Divider,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Flex,
  Text,
  VStack,
  Stack,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import PricingFooter from "@/components/pricingFooter";
import {BAREMETAL_SERVER_DATA, FOOTER_CONSTANTS} from "./constants";

export const DesktopView = () => {
  return (
    // <Box overflowX="auto" w="full">
    <TableContainer>
      <Table variant="striped" border={"2px solid rgb(237,242,247)"} width={"100%"}>
        <Thead>
          <Tr>
            <Th>Processor</Th>
            <Th>Memory</Th>
            <Th>Base Clock | Boost</Th>
            <Th>Disk</Th>
            <Th>Boot Drives</Th>
            <Th>Price / month</Th>
          </Tr>
        </Thead>
        <Tbody>
          {BAREMETAL_SERVER_DATA.map((plan, index) => (
            <Tr
              key={index}
              style={{whiteSpace: "nowrap"}}
              fontSize={"15px"}
              color="#2d3748"
            >
              <Td>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  flexDirection={"row"}
                  gap={"6px"}
                >
                  <Box
                    h="2rem"
                    position="relative"
                    w="2rem"
                    display={"flex"}
                    alignItems={"center"}
                    gap="2px"
                  >
                    <Image
                      src={plan.image}
                      alt="image"
                      sizes="38px"
                      style={{objectFit: "contain"}}
                    />
                  </Box>
                  <Flex direction={"column"} style={{whiteSpace: "nowrap"}}>
                    <Box>{plan.processor}</Box>
                    <Box style={{fontSize: "12px", color: "text.100"}}>{plan.sku}</Box>
                  </Flex>
                </Box>
              </Td>
              <Td style={{whiteSpace: "nowrap"}}>{plan.memory}</Td>
              <Td>{plan.baseclock_boost}</Td>
              <Td>{plan.disk}</Td>
              <Td>{plan.bootDrives}</Td>
              <Td>
                <Text fontWeight={"700"} fontSize={"18px"} color="blue.600">
                  {plan.price}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
    // </Box>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{base: 1, sm: 2}} spacing={6}>
      {BAREMETAL_SERVER_DATA.map((plan, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          spacing={4}
          w="100%"
          p={4}
          bg="white"
        >
          <HStack spacing={3} align="center" w="full">
            <Box
              h="3rem"
              w="3rem"
              position="relative"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="md"
              bg="gray.50"
            >
              <Image
                src={plan.image}
                alt="image"
                sizes="48px"
                style={{objectFit: "contain"}}
                fill
              />
            </Box>
            <Flex flex="1" direction="column">
              <Text fontWeight="bold" fontSize="lg">
                {plan.processor}
              </Text>
              <Text fontSize="sm" color="text.100">
                {plan.sku}
              </Text>
            </Flex>
          </HStack>

          <Divider borderColor="gray.200" />

          <HStack justify="center" w="full">
            <Text fontSize="sm" color="gray.600">
              Base Clock | Boost
            </Text>
            <Text fontWeight="semibold" fontSize="md">
              {plan.baseclock_boost}
            </Text>
          </HStack>

          <Stack
            direction="row"
            spacing={4}
            justify="space-between"
            w="full"
            flexWrap="wrap"
          >
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Memory
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.memory}
              </Text>
            </Flex>
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Disk
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.disk}
              </Text>
            </Flex>
          </Stack>

          <Stack
            direction="row"
            spacing={4}
            justify="space-between"
            w="full"
            flexWrap="wrap"
          >
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Boot Drives
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.bootDrives}
              </Text>
            </Flex>
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Price / mo
              </Text>
              <Text fontWeight="bold" fontSize="lg" color="blue.600">
                {plan.price}
              </Text>
            </Flex>
          </Stack>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const BaremetalTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="baremetal">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        Bare Metal Server
      </Heading>
      <Center display={{md: "none"}} w="full">
        <MobileView />
      </Center>
      <Box display={{base: "none", md: "block"}}>
        <DesktopView />
      </Box>
      <PricingFooter {...FOOTER_CONSTANTS} />
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default BaremetalTable;
